<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 md6>
        <v-layout column>
          <v-flex class="rect-x1 logo-container d-flex justify-space-between">
            <router-link
              :to="{ name: 'Homepage' }"
              title="Strona główna"
              class=""
              style="max-width: 50%"
            >
              <img src="/static/images/LOGO_STJ_2026.png?v=1" alt="" class="logo" />
            </router-link>
            <a href="#" class="d-flex justify-space-between px-4">
              <img src="/static/images/pto-compasspr.png" alt="" class="pto-n4d" />
            </a>
          </v-flex>

          <v-flex class="xs12 sm6 md12 hidden-sm-and-down">
            <my-button
              toName="Doctors"
              title="Dla lekarza"
              text="<span>strefa <br>dla lekarza</span>"
              customClass="doctor rect-x1"
            />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md6 class="rect-x2 free-tests">
        <img src="/static/images/free-wgw-control.svg?v=1" alt="" />
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 md6>
        <v-layout row wrap>
          <v-flex class="xs12 sm6 md12 hidden-md-and-up">
            <my-button
              toName="Doctors"
              title="Dla lekarza"
              text="<span>strefa <br>dla lekarza</span>"
              customClass="doctor rect-x1"
            />
            <!-- <my-button
              toName="PressConference"
              title="Konferencja prasowa"
              text="<span>konferencja<br>prasowa</span>"
              customClass="transmission rect-x1"
            /> -->
          </v-flex>

          <v-flex class="xs12 sm6 md12">
            <my-button
              toName="Register"
              title="Znajdź gabinet"
              text="<span>Zgłoś<br>gabinet</span>"
              customClass="transmission rect-x1"
            />
           </v-flex>

          <v-flex class="xs12 sm6 md12">
            
          </v-flex>

          <v-flex class="xs12 sm6 md12">
            <my-button
              toName="Patients"
              title="Dla pacjenta"
              text="<span>strefa <br>dla pacjenta</span>"
              customClass="patient rect-x1"
            />
          </v-flex>

          <!--          <v-flex class="xs12 sm6 md12" v-show="showWGW()">-->
          <!--            <my-button-->
          <!--              external="https://polskieforumjaskry.net4doctor.online/"-->
          <!--              title="V Polskie Forum Jaskry"-->
          <!--              text="<span>v polskie <br>forum jaskry</span>"-->
          <!--              customClass="forum rect-x1"-->
          <!--            />-->
          <!--          </v-flex>-->

          <v-flex class="xs12 sm6 md12">
            <!-- <my-button
              toName="Institutions"
              title="Znajdź gabinet"
              text="<span>Znajdź<br>gabinet</span>"
              customClass="transmission rect-x1"
            /> -->
            <my-button
              toName="PressConference"
              title="Konferencja prasowa"
              text="<span>konferencja<br>prasowa</span>"
              customClass="transmission rect-x1"
            />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md6 class="rect-x2 empty"> </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import MyButton from "@/components/partials/Button";
import moment from "moment";

export default {
  data() {
    return {
      startTransmission: "2022-03-22 10:00:00",
      endTransmission: "2022-03-22 20:00:00",
    };
  },
  components: {
    MyButton,
    moment,
  },
  computed: {
    transmission() {
      return (
        moment().isAfter(this.startTransmission) &&
        moment().isBefore(this.endTransmission)
      );
    },
  },
  methods: {
    showPressConference() {
      return (
        moment().isAfter(this.startTransmission) &&
        moment().isBefore(this.endTransmission)
      );
    },
    showWGW() {
      return (
        moment().isAfter("2022-03-05 23:59:59") &&
        moment().isBefore("2022-03-27 23:59:59")
      );
    },
  },
};
</script>

<style scoped lang="stylus">
.free-tests {
  background-color: rgba(217, 231, 238, 0.9);
  position: relative;

  &:before {
    content: '';
    position: absolute;
    left: 100%;
    top: 0;
    background-color: inherit;
    height: 100%;
    width: 100%;
  }

  &:after {
    content: '';
    position: absolute;
    display: none;

    @media only screen and (min-width: 960px) {
      left: 2rem;
      display: block;
    }

    bottom: 0;
    background-color: rgba(39, 82, 113, 0.9);
    height: 10px;
    width: 100px;
  }

  img {
    max-width: 240px;
    margin-left: -30px;

    @media only screen and (min-width: 960px) {
      max-width: 400px;
      margin-left: -52px;
    }
  }
}

.empty {
  background-color: transparent;
  position: relative;
  display: none;

  @media only screen and (min-width: 960px) {
    display: block;
  }

  &:after {
    content: '';
    position: absolute;
    left: 100%;
    top: 0;
    background-color: inherit;
    height: 100%;
    width: 100%;
  }
}

.occurence {
  font-size: 30px;
  font-weight: 700;

  @media only screen and (min-width: 960px) {
    font-size: 46px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Homepage.vue